<template>
  <div class="years is-flex wrap">
    <router-link
      :to="{
        path: path,
        query: {
          locationGroupId: locationGroupId,
          schoolYear: option.year,
          ...queryParams
        },
      }"
      v-for="(option, index) in years" :key="index"
      :disabled="disableYears"
      class="button has-no-underline"
      :class="{ 'active' : option.year === schoolYear}"
      replace
    >
      {{ option.year-1 }}-{{ option.year.toString(10).substring(2,4) }}
    </router-link>
  </div>
</template>

<script>
import store from '@/store';

export default {
  props: {
    disableYears: {
      type: Boolean,
    },
    locationGroupId: {
      type: [String, Number],
    },
    path: {
      type: String,
    },
    schoolYear: {
      type: Number,
    },
    cluster: {
      type: Boolean,
      default: false,
    },
    availableYears: {
      type: Array,
    },
  },
  data() {
    return {
      years: [],
    };
  },
  created() {
    this.calculateYears(store.state.propertiesModule.properties['CEP-CEP_CURRENT_SCHOOL_YEAR']);
  },
  computed: {
    queryParams() {
      const params = {};

      if (this.cluster) {
        params.cluster = this.cluster;

        if (this.availableYears) {
          params.years = this.availableYears;
        }
      }

      return params;
    },
  },
  watch: {
    availableYears() {
      if ((this.cluster && this.availableYears) || (!this.cluster && !this.availableYears)) {
        this.calculateYears(store.state.propertiesModule.properties['CEP-CEP_CURRENT_SCHOOL_YEAR']);
      }
    },
  },
  methods: {
    calculateYears(currentYear) {
      this.years = [];
      for (let i = 0; i < 5; i += 1) {
        const year = currentYear - i;
        if ((this.availableYears && this.availableYears.includes(year.toString()))
        || !this.availableYears) {
          this.years.push({ id: i + 1, year });
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .years
    margin: 0 1rem 1rem 1rem
    flex-direction: row-reverse
    .button
      min-width: 100px
      margin-left: 0.5rem
      &:not(.active):not(:hover):not(:focus)
        background-color: rgba(0,0,0,0)
        border: 1px solid rgba(0,0,0,0)
        color: $primary
        font-weight: 400
</style>
